window.menuFixedEvents = () => {
  $(document).ready(function () {
    scrollTo();
  });

  const scrollTo = () => {
    const menuList = document.querySelector('.jsMenuFixed');
    const listItem = menuList.querySelectorAll('.jsMenuFixedItem');

    listItem.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();

        const destinationAttr = item.getAttribute('data-dest');
        const destinationContainer = document.querySelector(`[id=${destinationAttr}]`)

        scroll({
          top: destinationContainer.offsetTop,
          behavior: "smooth"
        });
      });
    });
  };
};
